import React, { useState } from 'react';
import { css } from '@emotion/core';
import ReactPlayer from 'react-player';
import { buttonHover, buttonNormal } from '../../../constants/themes';
import IconSvg from '../IconSvg';
import { VideoModal } from '../../VideoPlayer/styled';

// usage example: Catalog/styled.js:268
const PopUpVideoLink = ({ message, videoUrl, extraCSS }) => {
  const [isVideoOpened, setVideoOpened] = useState(false);
  return (
    <>
      <a
        onClick={() => setVideoOpened(true)}
        css={css`
          color: ${buttonNormal} !important;
          &:hover {
            color: ${buttonHover} !important;
          }
          ${extraCSS}
        `}
      >
        {message}
        <IconSvg type="play" size={20} />
      </a>
      {isVideoOpened && (
        <VideoModal onCancel={() => setVideoOpened(false)} visible width={0} centered footer={null}>
          <ReactPlayer url={videoUrl} width={800} height={450} playing />
        </VideoModal>
      )}
    </>
  );
};

export default PopUpVideoLink;
